
import KindEditor from '../kindeditor.vue'
const install = function (Vue) {
  if (install.installed) return
  install.installed = true
  Vue.component('editor', KindEditor)
}
 
export default install


// WEBPACK FOOTER //
// ./src/assets/config/kindeditor.js